import cx from 'classnames';
import { BRAND_AMBASSADOR } from 'mk/autogenerated/translations/AmbasadorBadge.c48c35c16b539baa7f7f756ddef6b59e'
import React from 'react';
import styles from './AmbasadorBadge.mscss';

interface OwnProps {
    className?: string;
}

type Props = OwnProps;

const AmbasadorBadge: React.FunctionComponent<Props> = ({ className }) => (
    <span className={cx(styles.AmbasadorBadge, className)}>
        {BRAND_AMBASSADOR}
    </span>
);

AmbasadorBadge.displayName = 'AmbasadorBadge';

export default React.memo<Props>(AmbasadorBadge);
